import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { HeaderModuleModal } from "./Modals";
import api from "../lib/api";

/**
 * Posts is a real route link; only editable info panels come from modules.
 */
export default function Header() {
  const loc = useLocation();
  const onPosts = loc.pathname === "/posts";
  const [modules, setModules] = useState([]);
  const [modal, setModal] = useState(null);
  const [overflowOpen, setOverflowOpen] = useState(false);

  useEffect(() => {
    let active = true;
    const refreshModules = () => {
      if (document.visibilityState !== "visible") return;
      api.get("/header-modules", { headers: { "Cache-Control": "no-cache" } })
        .then((r) => { if (active) setModules(r.data?.items || []); })
        .catch(() => {});
    };
    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") refreshModules();
    };
    refreshModules();
    window.addEventListener("focus", refreshModules);
    document.addEventListener("visibilitychange", refreshWhenVisible);
    const interval = window.setInterval(refreshModules, 60000);
    return () => {
      active = false;
      window.removeEventListener("focus", refreshModules);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
      window.clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const key = window.location.hash.replace(/^#/, "");
    const match = modules.find((module) => module.key === key);
    if (match) setModal(match);
  }, [modules]);

  const openModule = (module) => {
    setModal(module);
    window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}#${module.key}`);
  };
  const closeModule = () => {
    setModal(null);
    window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
  };

  return (
    <>
      <header className="xs-header" data-testid="site-header">
        <div className="xs-header-center">
          <Link to="/" data-testid="header-home-link" aria-label="xaelserpent home">
            <Logo className="xs-logo" id="headerLogo" />
          </Link>
          <nav className="xs-header-links" aria-label="site navigation">
            <Link
              className={`xs-header-link ${onPosts ? "active" : ""}`}
              to="/posts"
              data-testid="header-posts-link"
            >posts</Link>
            {modules.length > 0 && <span className="xs-header-separator" aria-hidden="true">|</span>}
            {modules.length > 0 && <div className="xs-header-modules">
              {modules.slice(0, 3).map((module) => (
                <button className="xs-header-link" key={module.id} onClick={() => openModule(module)} data-testid={`header-${module.key}-link`}>
                  {module.label}
                </button>
              ))}
              {modules.length > 3 && (
                <div className="xs-header-overflow">
                  <button className="xs-header-link" onClick={() => setOverflowOpen((open) => !open)} aria-expanded={overflowOpen} aria-label="More information panels">more</button>
                  {overflowOpen && <div className="xs-header-overflow-menu">
                    {modules.slice(3).map((module) => <button className="xs-header-link" key={module.id} onClick={() => { setOverflowOpen(false); openModule(module); }}>{module.label}</button>)}
                  </div>}
                </div>
              )}
            </div>}
          </nav>
        </div>
      </header>
      {modal && <HeaderModuleModal module={modal} onClose={closeModule} />}
    </>
  );
}
